export default __webpack_public_path__ + "static/media/slack.0ac7f9b4.svg";